export default __webpack_public_path__ + "static/media/로보엠디_개인정보제3자제공및위탁제공_0511.cf0915a8.pdf";